import React from "react";
import styled from "styled-components";
import { X } from "lucide-react";

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001;
  opacity: ${props => props.isOpen ? 1 : 0};
  visibility: ${props => props.isOpen ? 'visible' : 'hidden'};
  transition: opacity 0.3s ease, visibility 0.3s ease;
  padding: 1rem;
`;

const ModalContent = styled.div`
  background-color: #FFFFFF;
  border-radius: 1rem;
  padding: 0;
  width: 100%;
  max-width: 600px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  transform: ${props => props.isOpen ? 'scale(1)' : 'scale(0.95)'};
  transition: transform 0.3s ease;
  font-family: 'Prompt', sans-serif;
  position: relative;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  cursor: pointer;
  color: #9CA3AF;
  padding: 0.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  z-index: 1;

  &:hover {
    color: #6B7280;
    background-color: #F3F4F6;
  }

  svg {
    width: 1.25rem;
    height: 1.25rem;
  }
`;

const ModalBody = styled.div`
  padding: 3rem 2rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
`;

const CheckIconContainer = styled.div`
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CheckImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const MessageText = styled.div`
  text-align: center;
`;

const MainText = styled.h3`
  color: #171717;
  font-size: 24px;
  font-weight: 400;
  margin: 0 0 0.5rem 0;
  line-height: 1.4;
`;

const SubText = styled.p`
  color: #171717;
  font-size: 24px;
  font-weight: 400;
  margin: 0;
  line-height: 1.4;
`;

const ModalFooter = styled.div`
  padding: 0 2rem 3rem 2rem;
  display: flex;
  justify-content: center;
`;

const ConfirmButton = styled.button`
  background-color: #00B5B8;
  color: white;
  border: none;
  border-radius: 0.5rem;
  padding: 0.75rem 3rem;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.2s;
  font-family: 'Prompt', sans-serif;

  &:hover {
    background-color: #009B9E;
    transform: translateY(-1px);
  }
`;

const ApproveHealthResultModal = ({ isOpen, onClose, onConfirm }) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose && onClose();
    }
  };

  const handleConfirm = () => {
    onConfirm && onConfirm();
    onClose && onClose();
  };

  return (
    <ModalOverlay isOpen={isOpen} onClick={handleOverlayClick}>
      <ModalContent isOpen={isOpen}>
        <CloseButton onClick={onClose}>
          <X />
        </CloseButton>

        <ModalBody>
          <CheckIconContainer>
            <CheckImage src="check.png" alt="Check" />
          </CheckIconContainer>

          <MessageText>
            <MainText>ยืนยันการอนุมัติ</MainText>
            <SubText>และจัดส่งผลการตรวจสุขภาพ</SubText>
          </MessageText>
        </ModalBody>

        <ModalFooter>
          <ConfirmButton onClick={handleConfirm}>
            ยืนยัน
          </ConfirmButton>
        </ModalFooter>
      </ModalContent>
    </ModalOverlay>
  );
};

export default ApproveHealthResultModal;
